import React from "react";
import { Drawer, IconButton, Typography } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  drawerContainer: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    position: "relative",
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      width: "100%",
      background:
        "linear-gradient(90deg, rgba(204,48,69,1) 0%, rgba(234,96,165,1) 20%, rgba(245,225,124,1) 40%, rgba(79,173,91,1) 60%, rgba(50,152,196,1) 80%, rgba(175,145,189,1) 100%)",
    },
    "&::before": {
      top: 0,
      left: 0,
      height: "8px",
    },
    "&::after": {
      bottom: 0,
      right: 0,
      height: "5px",
    },
  },
}));

const BaseDrawer = ({ onClose, children, headline = "" }) => {
  const classes = useStyles();

  return (
    <Drawer anchor="bottom" open={true} onClose={onClose}>
      <div className={classes.drawerContainer}>
        {headline && (
          <Typography
            variant="h3"
            align="center"
            sx={{ padding: "20px", fontSize: "20px", margin: "0" }}
          >
            {headline}
          </Typography>
        )}
        {children}
      </div>
      <IconButton onClick={onClose} sx={{ top: 10, right: 10, position: "absolute" }}>
        <HighlightOffIcon />
      </IconButton>
    </Drawer>
  );
};

export default BaseDrawer;
